module.exports = __webpack_public_path__ + "assets/img/Jurong East MRT Interchange.cd365c11.jpg";